// components/TemplateCard.js
export const TemplateCard = ({ template }) => {
    return (
        <div className="w-[280px] flex-shrink-0 px-4">
            <div className="bg-black rounded-[2rem] p-3">
                <div className={`bg-gradient-to-br ${template.gradient} rounded-[1.7rem] aspect-[9/19.5] p-6 text-white`}>
                    <div className="pt-8 text-center">
                        <div className="w-16 h-16 bg-white/20 rounded-full mx-auto mb-4"></div>
                        <h4 className="font-medium mb-2">@{template.name.toLowerCase()}</h4>
                        <div className="space-y-2">
                            {template.links.map((link, i) => (
                                <button key={i} className="w-full bg-white/10 backdrop-blur py-2.5 rounded-xl hover:bg-white/20 transition-colors">
                                    {link}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
